import { TextField } from 'components/mui';
import { NOTE } from 'containers/pages/contacts/constants';
import { func, object } from 'prop-types';

/**
 * @function InputNote
 * @param {ContactInfo} contact
 * @param {function} handleForm
 * @returns {JSX.Element}
 */
function InputNote({ contact, handleForm }) {
	return (
		<>
			<TextField
				name={NOTE}
				label="Notes"
				multiline
				minRows={3}
				maxRows={5}
				value={contact[NOTE]}
				InputLabelProps={{ shrink: true }}
				onChange={handleForm}
			/>
		</>
	);
}

InputNote.propTypes = {
	contact: object,
	handleForm: func,
};

export default InputNote;
